module.exports = __webpack_public_path__ + "img/icon_exclamation_mark.2ef60828.png";